<template>
  <div>
    <img src="/img/loader.gif" alt="Loading...">
  </div>
</template>

<script>
export default {
  name: 'Loader',
}
</script>

<style scoped>

</style>
